export enum HMSPollQuestionType {
  /**
   The question allows for a single choice answer.
   */
  singleChoice,

  /**
   The question allows for multiple choice answers.
   */
  multipleChoice,

  /**
   The question expects a short text answer.
   */
  shortAnswer,

  /**
   The question expects a long text answer.
   */
  longAnswer,
}
